import { AreaUnit, DistanceUnit, GeometryType } from "@nova/constants"
import { Ruler } from "@nova/protobuf"
import { createSlice } from "@reduxjs/toolkit"
import { RootState } from "integrations/redux"
import { DeckGLGeometry } from "plugins/shared/layers/types"

type EditingData = {
    id: string
    mockedRuler: DeckGLGeometry
}

type InitialState = {
    editingData?: EditingData
}

export const MOCKED_RULER_ID = "MOCKED_RULER_ID"
const initalRulerState = {} as InitialState

const name = "ruler-v1"
const {
    reducer: rulerReducer,
    actions: { moveRulerToEditable, createNewMockRuler, clearEditingData },
} = createSlice({
    name,
    initialState: { ...initalRulerState },
    reducers: {
        moveRulerToEditable: (state, action: { payload: Ruler }) => {
            const editingData = {} as EditingData
            editingData.mockedRuler = {
                ...action.payload,
                distanceUnit: action.payload.distanceUnit as DistanceUnit,
                areaUnit: action.payload.areaUnit as AreaUnit,
                idx: 0,
            }
            editingData.id = action.payload.id
            state.editingData = editingData
        },
        createNewMockRuler: (state) => {
            const editingData = {} as EditingData
            editingData.mockedRuler = {
                id: MOCKED_RULER_ID,
                coordinates: [],
                geometryType: GeometryType.Line,
                idx: 0,
            }
            editingData.id = MOCKED_RULER_ID
            state.editingData = editingData
        },
        clearEditingData: () => {
            return { ...initalRulerState }
        },
    },
})

const root = (s: RootState) => s[name]

export const selectRulerEditingData = (s: RootState) => root(s).editingData

export { moveRulerToEditable, createNewMockRuler, clearEditingData }
export const reducer = { [name]: rulerReducer }
